import { formatDate } from '@/lib/format';

// Visible freshness marker. The same ISO date goes into the page's JSON-LD
// dateModified, so readers and answer engines see one date.
const LastUpdated = ({ date, readingTime }: { date: string; readingTime?: string }) => (
  <p className="text-small text-forest/80">
    Last updated <time dateTime={date}>{formatDate(date)}</time>
    {readingTime && (
      <>
        <span aria-hidden className="mx-2">
          ·
        </span>
        <span>{readingTime} read</span>
      </>
    )}
  </p>
);

export default LastUpdated;
